import { render, staticRenderFns } from "./ApexServerData.vue?vue&type=template&id=bb381cc6&"
import script from "./ApexServerData.vue?vue&type=script&lang=js&"
export * from "./ApexServerData.vue?vue&type=script&lang=js&"
import style0 from "./ApexServerData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports